import React, { useEffect, useRef, useState } from "react";
import Button from "react-bootstrap/esm/Button";
import Card from "react-bootstrap/esm/Card";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import toast, { Toaster } from "react-hot-toast";
import { makeGetRequest } from "../../../../utils/api";
import { urls } from "../../../../utils/urls";
import { useLocation } from "react-router-dom";
import BackToGameList from "../../utils/BackToGameList";

function MemoryMatch() {
  const [number, setNumber] = useState(8);
  const [incorrectCount, setIncorrectCount] = useState(0);
  const [time, setTime] = useState(60);
  const [pairs, setPairs] = useState([]);
  const [oddOne, setOddOne] = useState([]);
  const [buttons, setButtons] = useState([]);
  const [items, setItems] = useState([]);
  const [guess, setGuess] = useState({ id: -1, type: -1 });
  const [pairedGuess, setPairedGuess] = useState([]);
  const [play, setPlay] = useState(false);
  const [gO, setGO] = useState(false);
  const [gameComplete, setGameComplete] = useState(false);
  const [intervalID, setIntervalID] = useState();
  const [correct, setCorrect] = useState(0);
  const [pregame, setPregame] = useState(false);
  const [timeoutTrigger, setTimeoutTrigger] = useState(false);

  const imageRefs = useRef([]);
  const imagePairsRefs = useRef([]);
  const buttonRefs = useRef([]);
  const buttonPairsRefs = useRef([]);

  const location = useLocation();

  const handleItems = async () => {
    const response = await makeGetRequest(
      urls.getIcons + "?active=True",
      "",
      true
    );
    setItems(response.data);
  };

  const startGame = () => {
    setGO(false);
    setGameComplete(false);
    for (let i = 0; i < number; i++) {
      pairs.push(
        <Col key={i} xs={3} style={{ textAlign: "center" }}>
          <Button
            key={i}
            style={{
              margin: "10px",
              width: "256px",
            }}
            variant="secondary"
            ref={(ref) => (buttonRefs.current[i] = ref)}
            onClick={() => setGuess({ id: i, type: 0 })}
          >
            <img
              src={items[i].image}
              ref={(ref) => (imageRefs.current[i] = ref)}
              style={{ width: "128px", height: "128px" }}
            />
          </Button>
        </Col>
      );
      pairs.push(
        <Col key={i + "p"} xs={3} style={{ textAlign: "center" }}>
          <Button
            key={i}
            style={{
              margin: "10px",
              width: "256px",
            }}
            variant="secondary"
            ref={(ref) => (buttonPairsRefs.current[i] = ref)}
            onClick={() => setGuess({ id: i, type: 1 })}
          >
            <img
              src={items[i].image}
              ref={(ref) => (imagePairsRefs.current[i] = ref)}
              style={{ width: "128px", height: "128px" }}
            />
          </Button>
        </Col>
      );
    }
    setButtons(
      pairs.map((pairButtons) => {
        return { value: pairButtons, id: Math.random() };
      })
    );
    handlePregame();
  };

  const pairCheck = () => {
    if (guess.id !== -1 && guess.id !== null && guess.id !== undefined) {
      if (pairedGuess.length === 2) {
        if (pairedGuess[0].id === pairedGuess[1].id) {
          setTimeout(() => {
            if (location.pathname === "/games/memory-match") {
              for (let i = 0; i < 2; i++) {
                buttonRefs.current[pairedGuess[i].id].style.backgroundColor =
                  "#6be0ff";
                buttonPairsRefs.current[
                  pairedGuess[i].id
                ].style.backgroundColor = "#6be0ff";
              }
              setCorrect((prevCorrect) => prevCorrect + 1);
            }
          }, 2000);
          setPairedGuess([]);
        } else {
          toast("Sorry that is an incorrect pair.", {
            duration: 3000,
            position: "right",
          });
          for (let i = 0; i < 2; i++) {
            if (pairedGuess[i].type === 0) {
              buttonRefs.current[pairedGuess[i].id].style.backgroundColor =
                "#ff6a6a";
            } else {
              buttonPairsRefs.current[pairedGuess[i].id].style.backgroundColor =
                "#ff6a6a";
            }
          }
          setTimeout(() => {
            if (location.pathname === "/games/memory-match") {
              for (let i = 0; i < 2; i++) {
                if (pairedGuess[i].type === 0) {
                  imageRefs.current[pairedGuess[i].id].style.opacity = 0;
                  buttonRefs.current[pairedGuess[i].id].style.backgroundColor =
                    "#0d6efd";
                } else {
                  imagePairsRefs.current[pairedGuess[i].id].style.opacity = 0;
                  buttonPairsRefs.current[
                    pairedGuess[i].id
                  ].style.backgroundColor = "#0d6efd";
                }
              }
              setPairedGuess([]);
            }
          }, 2000);
        }
      }
      setGuess({ id: -1, type: -1 });
    }
  };

  useEffect(() => {
    if (guess.id !== -1 && pregame === false) {
      setPairedGuess((prevGuess) => [...prevGuess, guess]);
    }
  }, [guess]);

  useEffect(() => {
    if (pairedGuess.length > 0) {
      if (pairedGuess.length < 2) {
        toast("Select the card that matches to complete the pair.", {
          duration: 2000,
          position: "right",
        });
        if (pairedGuess[0].type === 0) {
          imageRefs.current[pairedGuess[0].id].style.opacity = 1;
          buttonRefs.current[pairedGuess[0].id].style.backgroundColor =
            "#00a730";
        } else {
          imagePairsRefs.current[pairedGuess[0].id].style.opacity = 1;
          buttonPairsRefs.current[pairedGuess[0].id].style.backgroundColor =
            "#00a730";
        }
      }
      if (pairedGuess.length === 2) {
        if (pairedGuess[1].type === 0) {
          imageRefs.current[pairedGuess[1].id].style.opacity = 1;
          buttonRefs.current[pairedGuess[1].id].style.backgroundColor =
            "#00a730";
        } else {
          imagePairsRefs.current[pairedGuess[1].id].style.opacity = 1;
          buttonPairsRefs.current[pairedGuess[1].id].style.backgroundColor =
            "#00a730";
        }
        pairCheck();
      }
    }
  }, [pairedGuess]);

  useEffect(() => {
    if (correct > 0 && correct < 8) {
      toast(
        "You've successfully matched a pair! Good job! You are at " +
          correct +
          " out of " +
          number,
        {
          duration: 3000,
          position: "right",
        }
      );
    }
    if (correct === number) {
      setPlay(false);
      setItems([]);
      setPairs([]);
      setGameComplete(true);
      handleItems();
      hideImages();
    }
  }, [correct]);

  useEffect(() => {
    if (play) {
      const intervalId = setInterval(() => {
        if (play) {
          setTime((prevSeconds) => prevSeconds - 1);
        }
      }, 1000);
      setIntervalID(intervalId);
      return () => clearInterval(intervalId);
    }
  }, [play]);

  const gameOver = () => {
    setTime(120);
    setPairs([]);
    setItems([]);
    setPlay(false);
    setGO(true);
    handleItems();
    hideImages();
  };

  useEffect(() => {
    if (time <= 0 && pregame === false) {
      gameOver();
    }
  }, [time]);

  useEffect(() => {
    handleItems();
  }, []);

  const hideImages = () => {
    if (timeoutTrigger === true) {
      for (let i = 0; i < 8; i++) {
        imageRefs.current[i].style.opacity = 0;
        imagePairsRefs.current[i].style.opacity = 0;
        buttonRefs.current[i].style.backgroundColor = "#0d6efd";
        buttonRefs.current[i].disabled = false;
        buttonPairsRefs.current[i].style.backgroundColor = "#0d6efd";
        buttonPairsRefs.current[i].disabled = false;
      }
    }
  };

  const handlePregame = () => {
    setCorrect(0);
    setPregame(true);
    setPlay(true);
    // setTime(10);
    // setTimeout(() => {
    //   setTimeoutTrigger(true);
    // }, 10000);
  };

  useEffect(() => {
    if (timeoutTrigger === true) {
      setPlay(true);
      hideImages();
      setTime(120);
      setPregame(false);
    }
  }, [timeoutTrigger]);

  return (
    <>
      <BackToGameList />
      {!play ? (
        <Card style={{ marginTop: "5px" }}>
          <Card.Header style={{ textAlign: "center", fontSize: "24px" }}>
            <b>Memory Match</b>
          </Card.Header>
          <Card.Body style={{ textAlign: "center" }}>
            {gO
              ? <> 
                  <h1>
                    Looks like you ran out of time! Don't fret, to play again touch the Restart Game button below. Select the image, then select the pair that matches!
                  </h1>
                  <br />
                  <br />
                  <Button size='lg' onClick={() => window.location.reload()}>
                    Restart Game
                  </Button>
                </>
              : gameComplete === false
              ? <><h1>Look at all the pictures on the cards.<br />
                  Try to remember where each picture is.<br />
                  Tap a card to see the picture.<br />
                  Try to find another card with the same picture.<br />
                  If the pictures match, you found a pair!<br />
                  Keep going until you find all the pairs.<br />
                  Have fun and see how many matches you can make! </h1><br /><br />
                <Button size='lg' variant='success' onClick={startGame}>
                  See Cards
                </Button></>
              : <>Congratulations, you've found the all the matches! To play again touch the Restart Game button below. Select the image, then select the pair that matches!<br />
              <Button onClick={() => window.location.reload()}>
                Restart Game
              </Button></>}
            <br />
          </Card.Body>
        </Card>
      ) : (
        <Card style={{ marginTop: "5px" }}>
          <Row>
            <Col style={{ textAlign: "center" }}>
              {pregame
                ? <>
                    <h1>Remember as many as you can press the start button to hide the images and start the game!</h1>
                    <Button variant='success' size='lg' onClick={() => setTimeoutTrigger(true)}>Start Game</Button>
                  </>
                : <h1>Time Remaining: {time}</h1>}
            </Col>
          </Row>
          <Row>
            {buttons
              .map((b) => b)
              .sort((a, b) => a.id - b.id)
              .map((n) => {
                return n.value;
              })}
          </Row>
        </Card>
      )}
    </>
  );
}

export default MemoryMatch;
